import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {eventOptions} from 'lit-element';

/**
 * @summary PaginationElement
 * @extends {AoflElement}
 */
@customElement('pagination-element')
class PaginationElement extends AoflElement {
  /**
   * Creates an instance of PaginationElement.
   */
  constructor() {
    super();
  }

  @property({converter(value) {
    const arr = [];
    for (let i = 0; i < Number(value); i++) {
      arr.push(i + 1);
    }
    return arr;
  }})
  ['num-pages'] = [];
  @property({type: Number})
  ['current-page'] = 1;
  @property({type: Number})
  ['visible-range'] = 7;
  @property({type: Boolean})
  ['disable-prev-next'] = false;
  @property({type: Boolean})
  ['disable-pages'] = false;
  @property({type: Boolean})
  ['enable-goto'] = false;
  @property({type: Boolean})
  ['disable-links'] = false;
  @property({type: Boolean})
  disabled = false;


  /**
   * @readonly
   */
  static get is() {
    return 'pagination-element';
  }

  @eventOptions({capture: true})
  clickHandler(e) {
    e.preventDefault();
    const target = e.currentTarget;
    this.setCurrentPage(target.dataset.pageNumber);
  }

  gotoSubmit(e) {
    e.preventDefault();
    if (this.disabled) return;
    const formData = new FormData(e.target);
    const selectedPage = formData.get('current-page');
    if (selectedPage > 0 && selectedPage <= this['num-pages'].length) {
      this.setCurrentPage(selectedPage);
    }
  }

  setCurrentPage(num) {
    let pageNumber = Number(num);
    if (pageNumber > this['num-pages']) {
      pageNumber = this['num-pages'];
    } else if (pageNumber < 0) {
      pageNumber = 0;
    }
    this.dispatchEvent(new CustomEvent('page-change', {
      composed: true,
      detail: {
        pageNumber
      }
    }));
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export {PaginationElement};

